
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subjects-list",
      function () {
        return require("private-next-pages/subjects-list/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subjects-list"])
      });
    }
  